import { Store } from 'pullstate';
import { PuzzleStoreBase, PuzzleStoreBaseDefaults } from '../../../utils/types';

export type ArithmeglyphsStoreType = PuzzleStoreBase & {
  completed: boolean;
  focusLocation: {
    lineNumber: number;
    index: number;
  };
  dataByLine: {
    opSeq: string;
    numSeq: string;
    guesses: (string | null)[];
    revealedCells: boolean[];
    // When Check is used, a mistake is marked with an X, or it's marked revealed if it's right.
    // Glyphs marked as mistakes aren't persisted, so a refresh just clears that glyph.
    mistakes: boolean[];
  }[];
  thirdLineNumSeq: string;
  checkDropdownIsOpen: boolean;
  revealDropdownIsOpen: boolean;
  combinedDropdownIsOpen: boolean;
  glyphReferenceIsOpen: boolean;
  confirmationDialogs: {
    revealGlyphIsOpen: boolean;
    revealLineIsOpen: boolean;
    revealPuzzleIsOpen: boolean;
    checkGlyphIsOpen: boolean;
    checkLineIsOpen: boolean;
    checkPuzzleIsOpen: boolean;
  }
};

export const ArithmeglyphsStore = new Store<ArithmeglyphsStoreType>({
  ...PuzzleStoreBaseDefaults,
  completed: false,
  focusLocation: {
    lineNumber: 1,
    index: 0,
  },
  dataByLine: [],
  thirdLineNumSeq: '',
  checkDropdownIsOpen: false,
  revealDropdownIsOpen: false,
  combinedDropdownIsOpen: false,
  glyphReferenceIsOpen: false,
  confirmationDialogs: {
    revealGlyphIsOpen: false,
    revealLineIsOpen: false,
    revealPuzzleIsOpen: false,
    checkGlyphIsOpen: false,
    checkLineIsOpen: false,
    checkPuzzleIsOpen: false,
  }
});